"use client";

import type { MouseEventHandler } from "react";
import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import Slider from "react-slick";
import market_icon_1 from "/public/img/market-icon-1.png";
import market_icon_2 from "/public/img/market-icon-2.png";
import market_icon_3 from "/public/img/market-icon-3.png";
import market_icon_4 from "/public/img/market-icon-4.png";
import market_icon_5 from "/public/img/market-icon-5.png";
import market_icon_6 from "/public/img/market-icon-6.png";

/** react-slick clones custom arrows and injects `onClick`, so it is optional here. */
interface SlickArrowProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const Next = ({ onClick }: SlickArrowProps) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className="slick-prev pull-left slick-arrow">
      <i className="icon-c-left-single" aria-hidden="true"></i>
    </button>
  );
};

const Prev = ({ onClick }: SlickArrowProps) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className="slick-next pull-right slick-arrow">
      <i className="icon-d-right-single" aria-hidden="true"></i>
    </button>
  );
};

const MarketSolutions = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    focusOnSelect: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <Next />,
    nextArrow: <Prev />,
    dots: true,
    dotsClass: "section-dots",
    customPaging: function () {
      return (
        <button className="dot" type="button" title="">
          <span className="string"></span>
        </button>
      );
    },
  };

  return (
    <section className="market-solutions">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row cus-mar">
            <div className="col-lg-7 d-flex align-items-center">
              <div className="section-header">
                <h2 className="title">Industry payout playbooks</h2>
                <p>
                  Agencies, dev shops, and creative studios use OracleMarket to
                  standardize how they settle invoices—whether clients pay by
                  card today and migrate to ACH tomorrow.
                </p>
                <Link href="/index-6" className="cmn-btn">
                  Find out solutions
                </Link>
              </div>
            </div>
            <div className="col-lg-5">
              <Slider {...settings} className="market-carousel">
                <div className="single">
                  <div className="single-item">
                    <div className="icon">
                      <div className="iconbg">
                        <Image src={market_icon_1} alt="icon" />
                      </div>
                    </div>
                    <div className="bottom text-center">
                      <h5>Online-Retail</h5>
                    </div>
                  </div>
                </div>
                <div className="single">
                  <div className="single-item">
                    <div className="icon">
                      <div className="iconbg">
                        <Image src={market_icon_2} alt="icon" />
                      </div>
                    </div>
                    <div className="bottom text-center">
                      <h5>Marketplaces</h5>
                    </div>
                  </div>
                </div>
                <div className="single">
                  <div className="single-item">
                    <div className="icon">
                      <div className="iconbg">
                        <Image src={market_icon_3} alt="icon" />
                      </div>
                    </div>
                    <div className="bottom text-center">
                      <h5>Games</h5>
                    </div>
                  </div>
                </div>
                <div className="single">
                  <div className="single-item">
                    <div className="icon">
                      <div className="iconbg">
                        <Image src={market_icon_4} alt="icon" />
                      </div>
                    </div>
                    <div className="bottom text-center">
                      <h5>Travel</h5>
                    </div>
                  </div>
                </div>
                <div className="single">
                  <div className="single-item">
                    <div className="icon">
                      <div className="iconbg">
                        <Image src={market_icon_5} alt="icon" />
                      </div>
                    </div>
                    <div className="bottom text-center">
                      <h5>Utility Services</h5>
                    </div>
                  </div>
                </div>
                <div className="single">
                  <div className="single-item">
                    <div className="icon">
                      <div className="iconbg">
                        <Image src={market_icon_6} alt="icon" />
                      </div>
                    </div>
                    <div className="bottom text-center">
                      <h5>Subscription services</h5>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketSolutions;
